// extracted by mini-css-extract-plugin
export default {"LookerIframeContainer":"LookerIframeContainerosaGT","lookerIframeContainer":"LookerIframeContainerosaGT"};